import React, { forwardRef } from "react";
import Navbar from "../../posnavbar/Navbar";
import { Box, Button, CircularProgress } from "@mui/material";
import { Grid } from "@mui/material";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import moment from "moment";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { getCashDrawerDetails } from "../../../../config/Services";
import { useSnackbar } from "../hooks/SnackbarProvider";
import { convertToLocalDateTime } from "../all-products/Middleware/commonUtils";

const columns = [
  {
    field: "updatedBy",
    headerName: "Updated by",
    minWidth: 150,
    flex: 0.75,
    headerClassName: "datagrid-columns",
    headerAlign: "center",
    cellClassName: "datagrid-rows",
    align: "center",
  },
  {
    field: "openingTime",
    headerName: "Opening time",
    minWidth: 150,
    flex: 0.75,
    headerClassName: "datagrid-columns",
    headerAlign: "center",
    cellClassName: "datagrid-rows",
    align: "center",
  },
  {
    field: "closingTime",
    headerName: "Closing time",
    minWidth: 150,
    flex: 0.75,
    headerClassName: "datagrid-columns",
    headerAlign: "center",
    cellClassName: "datagrid-rows",
    align: "center",
  },
  {
    field: "openingBalance",
    headerName: "Opening balance",
    minWidth: 150,
    flex: 0.75,
    headerClassName: "datagrid-columns",
    headerAlign: "center",
    cellClassName: "datagrid-rows",
    align: "center",
  },
  {
    field: "closingBalance",
    headerName: "Closing balance",
    minWidth: 150,
    flex: 0.75,
    headerClassName: "datagrid-columns",
    headerAlign: "center",
    cellClassName: "datagrid-rows",
    align: "center",
  },
];

const Drawer = () => {
  const showSnackbar = useSnackbar();
  const [tableRows, setTableRows] = useState([]);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);

  const sessionId = localStorage.getItem("sessionId");

  const drawerQuery = useQuery(["drawerDetails"], () => getCashDrawerDetails(sessionId), {
    enabled: !!sessionId,
    onSuccess: (response) => {
      if (response?.data?.es !== 0) {
        showSnackbar(response?.data?.message, "error");
        return;
      }
      if (!response?.data?.cashDrawer?.activities) {
        setTableRows([]);
        return;
      }
      const dataArr = response?.data?.cashDrawer?.activities?.map((row, i) => ({
        id: i,
        openingTime: row.openingTime ? convertToLocalDateTime(row.openingTime) : "----",
        closingTime: row.closingTime ? convertToLocalDateTime(row.closingTime) : "-----",
        openingBalance: row.openingBalance ? row.openingBalance : "-----",
        closingBalance: row.closingBalance ? row.closingBalance : "-----",
        updatedBy: row.updatedBy ? row.updatedBy : "-----",
      }));

      setTableRows(dataArr.sort((a, b) => b.openingTime.localeCompare(a.openingTime)));
      useSnackbar(response?.data?.message, "success");
    },
    onError: (error) => {
      showSnackbar(error?.response?.data?.message || error?.message, "error");
    },
  });

  const renderContent = () => {
    if (!sessionId) {
      return (
        <Box className="customer-no-data-box">
          <Box
            sx={{
              height: "525px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h3>Session not found</h3>
          </Box>
        </Box>
      );
    }
    if (drawerQuery.isLoading) {
      return (
        <Box
          sx={{
            height: "525px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <CircularProgress color="success" sx={{ color: "#5271ff" }} size={50} />
        </Box>
      );
    }
    if (tableRows.length) {
      return (
        <Box sx={{ height: "525px" }} className="">
          <DataGrid
            rows={tableRows}
            columns={columns}
            getRowId={(row) => row.id}
            initialState={{
              pagination: {
                pageSize: 8,
              },
            }}
            disableSelectionOnClick
            disableColumnMenu
            autoHeight
          />
        </Box>
      );
    }
    return (
      <Box
        sx={{
          height: "525px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3>No data found</h3>
      </Box>
    );
  };

  return (
    <Navbar>
      <Box className="customer-main-box">{renderContent()}</Box>
    </Navbar>
  );
};

export default Drawer;
